import { observer } from "mobx-react";
import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "components/flexComponents/Flights/components/l10";
import { FareCalendar } from "typings/microserviceModels/flights-flex-module";
import { UitkText } from "@egds/react-core/text";
import { UitkLink } from "@egds/react-core/link";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { UitkSpacing } from "@egds/react-core/spacing";

export const TooltipContent = observer((fareCalendar: FareCalendar) => {
  const {
    formattedDepartureDate,
    formattedReturnDate,
    originName,
    destinationName,
    formattedTicketPrice,
    airlineName,
    searchUrl,
    originIataCode,
    destinationIataCode,
  } = fareCalendar;
  const { formatText } = useLocalization();

  return (
    <>
      <UitkText size={200}>
        {formattedDepartureDate} - {formattedReturnDate}
      </UitkText>
      <UitkLink size="small" inline>
        <TrackedLink moduleName="FlightBarChart" href={searchUrl} rfrr="flightBarChart">
          <UitkSpacing padding={{ block: "one" }}>
            <UitkLayoutFlex>
              <UitkLayoutFlexItem>
                <UitkText size={200} overflow="truncate">
                  ({originIataCode}) {originName}
                </UitkText>
              </UitkLayoutFlexItem>
              <UitkLayoutFlexItem>
                <UitkText size={200} overflow="truncate">
                  - ({destinationIataCode}) {destinationName}
                </UitkText>
              </UitkLayoutFlexItem>
            </UitkLayoutFlex>
          </UitkSpacing>
        </TrackedLink>
      </UitkLink>
      <UitkText size={200} weight="bold" overflow="truncate">
        {formatText(locKeys.flightBarChartTooltip, formattedTicketPrice, airlineName)}
      </UitkText>
    </>
  );
});
